import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoute } from "@react-navigation/native";
import { useConversationContext } from "./ConversationContext";
import { Heading, Label } from "./Text";
import { View } from "./View";
/**
 * Renders the chat header for a conversation screen. It retrieves the
 * conversation title and session number from the route parameters.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-54}
 */ export function ChatHeader() {
    var _route_params, _route_params1;
    var route = useRoute();
    var _route_params_title;
    var title = (_route_params_title = (_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.title) !== null && _route_params_title !== void 0 ? _route_params_title : '';
    var _route_params_num;
    var sessionNum = (_route_params_num = (_route_params1 = route.params) === null || _route_params1 === void 0 ? void 0 : _route_params1.num) !== null && _route_params_num !== void 0 ? _route_params_num : null;
    var accentColor = useConversationContext().accentColor;
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            paddingTop: 80
        },
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                level: 1,
                text: title,
                textAlign: "center"
            }),
            sessionNum !== null ? /*#__PURE__*/ _jsxs(View, {
                style: {
                    marginTop: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        text: "Session ".concat(sessionNum),
                        textAlign: "center"
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            backgroundColor: accentColor,
                            marginLeft: -25,
                            height: 2,
                            width: 50,
                            marginTop: 7,
                            marginBottom: 10,
                            alignSelf: 'center'
                        }
                    })
                ]
            }) : null
        ]
    });
}
